import {AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {GenericPiece} from '../../entities/piece-jointe';
import {LiveAnnouncer} from '@angular/cdk/a11y';

@Directive({
    selector: '[jhiA11yDragNDropDirective]'
})
export class A11yDragNDropDirective implements AfterViewInit {
    private _selectedItem: string;
    @Input() piece: GenericPiece;
    @Input() index: number;
    @Input() set selectedItem(selectedItem: string) {
        this._selectedItem = selectedItem;
        if (this.isSelected(this.piece)) {
            this.el.nativeElement.classList.add('is-pressed');
        } else {
            this.el.nativeElement.classList.remove('is-pressed');
        }
    }

    @Output() a11yMoveup = new EventEmitter<any>();
    @Output() a11yMovedown = new EventEmitter<any>();
    @Output() a11ySelect = new EventEmitter<any>();
    @Output() a11yEscape = new EventEmitter<any>();

    constructor(private el: ElementRef,
                private liveAnnouncer: LiveAnnouncer) {}

    ngAfterViewInit() {
        this.el.nativeElement.setAttribute('aria-label', this.getFileName(this.piece));
    }

    private getFileName(piece: GenericPiece): string {
        return piece && piece.fileModel &&
        piece.fileModel.fileItem ? piece.fileModel.fileItem.name : '';
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: any) {
        switch (event.key) {
            case 'ArrowUp':
                this.onArrowUp();
                break;
            case 'ArrowDown':
                this.onArrowDown();
                break;
            case 'Space':
                this.onSelect();
                break;
            case ' ':
                this.onSelect();
                break;
            case 'Enter':
                this.onSelect();
                break;
            case 'Escape':
                this.onEscape();
        }
    }

    onArrowUp() {
        if (this.isSelected(this.piece)) {
            console.log('onArrowUp');
            this.a11yMoveup.emit({'i': this.index, 'piece': this.piece});
            this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est deplacé vers le haut');
            event.preventDefault();
        }
    }

    onArrowDown() {
        if (this.isSelected(this.piece)) {
            console.log('onArrowDown');
            this.a11yMovedown.emit({'i': this.index, 'piece': this.piece});
            this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est deplacé vers le bas');
            event.preventDefault();
        }
    }

    onSelect() {
        if (!this.isSelected(this.piece)) {
            this.a11ySelect.emit({'i': this.index, 'piece': this.piece});
            this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est sélectionné');
            event.preventDefault();
        } else {
            this.onEscape();
        }
    }

    onEscape() {
        this.a11yEscape.emit({'i': this.index, 'piece': this.piece});
        this.liveAnnouncer.announce(this.getFileName(this.piece) + ' est désélectionné');
        event.preventDefault();
    }

    isSelected(piece: GenericPiece): boolean {
        return this._selectedItem === piece.fileModel.fileApiId;
    }

    // pour garder le focus quand l'element se deplace
    @HostListener('document:keydown', ['$event'])
    onKeyDownAll(event: KeyboardEvent): void {
        const selectedItemElem = document.getElementById(this._selectedItem);
        switch (event.key) {
            case 'ArrowUp':
                if (this._selectedItem) {
                    event.preventDefault();
                    if (selectedItemElem) {
                        selectedItemElem.focus();
                    }
                    console.log('Focus elem', this._selectedItem);
                }
                break;
            case 'Escape':
                event.preventDefault();
                this.liveAnnouncer.announce('annulé');
                if (selectedItemElem) {
                    selectedItemElem.blur();
                }
                console.log('Escape', selectedItemElem);
                this.a11yEscape.emit({'i': this.index, 'piece': this.piece});
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/directives/a11y-drag-n-drop.directive.ts